import type { MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { PageResult } from '../../shared/data/types';
import type {
  AgentDetail,
  AgentListQuery,
  AgentSummary,
  ChangeAgentStatusInput,
  CreateAgentInput,
  DefaultUplineInput,
  HouseMember,
  HouseMemberInput,
  UpdateAgentInput,
} from './types';

export interface AgentRepository {
  list(query: AgentListQuery, signal: AbortSignal): Promise<PageResult<AgentSummary>>;
  get(agentId: string, signal: AbortSignal): Promise<AgentDetail>;
  create(input: CreateAgentInput): Promise<MutationResult<AgentDetail>>;
  update(agentId: string, input: UpdateAgentInput): Promise<MutationResult<AgentDetail>>;
  setDefaultUpline(
    agentId: string,
    input: DefaultUplineInput,
  ): Promise<MutationResult<AgentDetail>>;
  createHouseMember(agentId: string, input: HouseMemberInput): Promise<MutationResult<HouseMember>>;
  changeStatus(
    agentId: string,
    input: ChangeAgentStatusInput,
  ): Promise<MutationResult<AgentDetail>>;
}

export const agentRepositoryToken = createRepositoryToken<AgentRepository>('agents');

export const defaultAgentListQuery: AgentListQuery = Object.freeze<AgentListQuery>({
  page: 1,
  pageSize: 25,
  sort: 'updatedAt',
  order: 'desc',
  filters: { partnerId: '', code: '', name: '', status: '' as const },
});
